import {createSlice} from "@reduxjs/toolkit";
import {getExpertPaymentHistory} from "../actions/expertRevenueManagment";


export enum PaymentStatus {
  Pending = 0,
  Paid = 1
}

export interface IPaymentHistoryItem {
  id: number
  date: string
  totalAmount: number
  bankFee: number
  status: PaymentStatus
  referenceNo: string
}

export interface IPayment {
  paymentHistory: IPaymentHistoryItem[];
  loading: boolean,
}

const initialState: IPayment = {
  paymentHistory: [],
  loading: false,
};

export const paymentHistorySlice = createSlice({
  name: "revenueManagementSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getExpertPaymentHistory.pending, (state, action) => {
      state.loading = true;
    })
    builder.addCase(getExpertPaymentHistory.rejected, (state, action) => {
      state.loading = false;
    })
    builder.addCase(getExpertPaymentHistory.fulfilled, (state, action) => {
      state.loading = false;
      state.paymentHistory = action.payload;
    })
  }
});

export default paymentHistorySlice.reducer
